// Generated by CoffeeScript 1.4.0

(function($) {
  return $.fn.ajaxChosen = function(settings, callback, chosenOptions, errorCallback) {
    var chosenXhr, defaultOptions, options, select;
    if (settings == null) {
      settings = {};
    }
    if (chosenOptions == null) {
      chosenOptions = {};
    }
    defaultOptions = {
      minTermLength: 3,
      afterTypeDelay: 500,
      jsonTermKey: "term",
      keepTypingMsg: "Keep typing...",
      lookingForMsg: "Looking for"
    };
    select = this;
    chosenXhr = null;
    options = $.extend({}, defaultOptions, $(select).data(), settings);
    this.chosen(chosenOptions ? chosenOptions : {});
    return this.each(function() {
      var current_select = this
      if(chosenOptions.enable_include_remote){
        $(this).next('.chosen-container').on("click", ".chosen-load-more", function(e){
          e.preventDefault()
          options.data.includes_remote = true
          $(current_select).next(".chosen-container").find(".icon-spin").removeClass("hide")
          $(current_select).next(".chosen-container").find(".chosen-load-more span").text(i18n.t("Loading More Results"))
          $(current_select).next('.chosen-container').find(".search-field > input, .chosen-search > input").trigger("keyup")
        })
      }
      $(this).next('.chosen-container').find(".search-field > input, .chosen-search > input").unbind('keyup')
      return $(this).next('.chosen-container').find(".search-field > input, .chosen-search > input").bind('keyup', function(e) {
        if($.inArray(e.keyCode, [91, 17, 13, 38, 40]) >= 0){
          if(e.keyCode == 13){
            select.data().chosen.result_select(e)
          }
          return true
        }
        var field, msg, success, untrimmed_val, val;
        untrimmed_val = $(this).val();
        val = $.trim($(this).val());
        msg = val.length < options.minTermLength ? options.keepTypingMsg : options.lookingForMsg + (" '" + val + "'");
        select.next('.chosen-container').find('.no-results').text(msg);
        if (val === $(this).data('prevVal') && (chosenOptions.enable_include_remote && options.includes_remote)) {
          return false;
        }
        if(val != $(this).data("prevVal")){
          if(options && options.data){
            options.data.includes_remote = false
          }
          select.data().chosen.includes_remote = false
        }

        $(this).data('prevVal', val);
        if (this.timer) {
          clearTimeout(this.timer);
        }
        if (val.length < options.minTermLength) {
          return false;
        }
        field = $(this);
        if (options.data == null) {
          options.data = {};
        }
        options.data[options.jsonTermKey] = val;
        if (options.dataCallback != null) {
          options.data = options.dataCallback(options.data);
        }
        success = options.success;
        options.success = function(data) {
          var items, nbItems, selected_values;
          if (data == null) {
            return;
          }
          selected_values = [];
          select.find('option').each(function() {
            if (!$(this).is(":selected") && !data.includes_remote) {
              return $(this).remove();
            } else {
              return selected_values.push($(this).val() + "-" + $(this).text());
            }
          });
          select.find('optgroup:empty').each(function() {
            return $(this).remove();
          });
          items = callback != null ? callback(data, field) : data;
          nbItems = 0;
          $.each(items, function(i, element) {
            var group, text, value;
            nbItems++;
            if (element.group) {
              group = select.find("optgroup[label='" + element.text + "']");
              if (!group.size()) {
                group = $("<optgroup />");
              }
              group.attr('label', element.text).appendTo(select);
              return $.each(element.items, function(i, element) {
                var text, value;
                if (typeof element === "string") {
                  value = i;
                  text = element;
                } else {
                  value = element.value;
                  text = element.text;
                }
                if ($.inArray(value + "-" + text, selected_values) === -1) {
                  return $("<option />").attr('value', value).html(text).appendTo(group);
                }
              });
            } else {
              if (typeof element === "string") {
                value = i;
                text = element;
              } else {
                value = element.value;
                text = element.text;
              }
              if ($.inArray(value + "-" + text, selected_values) === -1 && $.inArray(value + "-" + $("<div>" + text + "</div>").text(), selected_values) === -1) {
                return $("<option />").attr('value', value).html(text).appendTo(select);
              }
            }
          });
          if(data.includes_remote){
            select.data().chosen.includes_remote = true
          }else{
            select.data().chosen.includes_remote = false
          }

          if (nbItems) {
            select.trigger("chosen:updated");
          } else {
            select.data().chosen.no_results_clear();
            select.data().chosen.no_results(field.val());
          }
          if (settings.success != null) {
            settings.success(data);
          }

          field.val(untrimmed_val);
          select.data().chosen.results_showing=false
          return select.data().chosen.results_toggle()
        };
        options.error = function(data){
          options.data.includes_remote = false
          if(errorCallback != null){
            var data_object = JSON.parse(data.responseText)
            errorCallback(data_object)
          }
        };
        return this.timer = setTimeout(function() {
          if (chosenXhr) {
            chosenXhr.abort();
          }
          return chosenXhr = $.ajax(options);
        }, options.afterTypeDelay);
      });
    });
  };
})(jQuery);
